import { FaUsers, FaMoneyBillWave, FaChartLine, FaHandshake } from 'react-icons/fa';
import SEO from '../components/SEO';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Affiliate = () => {
  const benefits = [
    {
      icon: <FaMoneyBillWave className="w-8 h-8" />,
      title: "High Commission Rates",
      description: "Earn 30% recurring commission on all referred customers for the lifetime of their subscription"
    },
    {
      icon: <FaUsers className="w-8 h-8" />,
      title: "30-Day Cookie Window",
      description: "Get credited for any purchase your referral makes within 30 days of clicking your link"
    },
    {
      icon: <FaChartLine className="w-8 h-8" />,
      title: "Real-Time Analytics",
      description: "Track your referrals, conversions, and earnings with our detailed dashboard"
    },
    {
      icon: <FaHandshake className="w-8 h-8" />,
      title: "Dedicated Support",
      description: "Get priority support and custom marketing materials to boost your success"
    }
  ];

  const tiers = [
    {
      level: "Bronze",
      monthly: "$0 - $1,000",
      commission: "30%",
      requirements: "0-5 active referrals"
    },
    {
      level: "Silver",
      monthly: "$1,001 - $5,000",
      commission: "35%",
      requirements: "6-20 active referrals"
    },
    {
      level: "Gold",
      monthly: "$5,001+",
      commission: "40%",
      requirements: "21+ active referrals"
    }
  ];

  return (
    <>
      <SEO 
        title="Affiliate Program - ViralVoice AI"
        description="Join our affiliate program and earn recurring commissions by promoting ViralVoice AI"
      />
      <Navbar />
      <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-20">
        {/* Hero Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
              Partner With Us
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-12">
              Join our affiliate program and earn recurring commissions by helping creators automate their social media engagement
            </p>
            <a 
              href="/signup?ref=affiliate" 
              className="inline-flex items-center px-8 py-3 border border-transparent text-base font-medium rounded-full text-black bg-gradient-to-r from-green-400 to-blue-500 hover:from-green-500 hover:to-blue-600 md:py-4 md:text-lg md:px-10"
            >
              Become an Affiliate
            </a>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Why Partner With Us?
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="bg-gray-800/50 backdrop-blur-xl rounded-xl p-6 border border-gray-700/50"
              >
                <div className="text-green-400 mb-4">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
                <p className="text-gray-400">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Commission Tiers */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Commission Tiers
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {tiers.map((tier, index) => (
              <div 
                key={index}
                className="bg-gray-800/50 backdrop-blur-xl rounded-xl p-8 border border-gray-700/50"
              >
                <h3 className="text-2xl font-bold mb-4">{tier.level}</h3>
                <div className="space-y-4">
                  <div>
                    <p className="text-gray-400">Monthly Revenue</p>
                    <p className="text-xl font-semibold">{tier.monthly}</p>
                  </div>
                  <div>
                    <p className="text-gray-400">Commission Rate</p>
                    <p className="text-xl font-semibold text-green-400">{tier.commission}</p>
                  </div>
                  <div>
                    <p className="text-gray-400">Requirements</p>
                    <p className="text-sm">{tier.requirements}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* FAQ Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-3xl mx-auto space-y-8">
            <div>
              <h3 className="text-xl font-semibold mb-2">How do I get started?</h3>
              <p className="text-gray-400">Sign up for our affiliate program, get your unique referral link, and start sharing. We'll track all referrals automatically.</p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">When do I get paid?</h3>
              <p className="text-gray-400">Commissions are paid monthly via PayPal or bank transfer, with a minimum payout threshold of $50.</p>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-2">What marketing materials do you provide?</h3>
              <p className="text-gray-400">We provide banners, email templates, social media content, and custom landing pages for our affiliates.</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Affiliate; 